/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_Zoom_InInputs */

const cs_workflow_zoom_in = /** @type {(inputs: Workflow_Zoom_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přiblížit`)
};

const en_workflow_zoom_in = /** @type {(inputs: Workflow_Zoom_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoom in`)
};

/**
* | output |
* | --- |
* | "Zoom in" |
*
* @param {Workflow_Zoom_InInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const workflow_zoom_in = /** @type {((inputs?: Workflow_Zoom_InInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_Zoom_InInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_zoom_in(inputs)
	return cs_workflow_zoom_in(inputs)
});